import React, {useCallback, useContext, useMemo, useState} from 'react';
import styles from "./styles.module.scss";
import useTranslation from "next-translate/useTranslation";
import Image from "next/image";
import img from "/public/aboutUs/hero.png";
import cn from "classnames";
import YouTubePlayer from "youtube-player";
import {ABOUT_NAMESPACE} from "../../../../utils/i18nNameSpaces";
import {checkUsableCookie} from "../../../../helpers/cookie/checkUsableCookie";
import {COOKIE_FUNCTIONALITY} from "../../../../utils/constants";
import {COOKIE_CONTEXT} from "../../../providers/CookieProvider";

const videoId = "nVj7Vx7HEjE";

const Index = () => {
  const [player, setPlayer] = useState(null);
  const {t} = useTranslation(ABOUT_NAMESPACE);
  const {openBanner, openCookieToast} = useContext(COOKIE_CONTEXT);
  const [isActive, setIsActive] = useState(false);

  const handleClick = useCallback(() => {
    // if (!checkUsableCookie(COOKIE_FUNCTIONALITY)) {
    //   openBanner(COOKIE_FUNCTIONALITY);
    //   openCookieToast();
    //   return;
    // }
    setIsActive(true);

    if (!player) {
      setPlayer(YouTubePlayer("player", {
        videoId: videoId,
      }))
    }
  }, [player, isActive]);

  const handleClose = useCallback(() => {
    setIsActive(false);

    if (player) {
      player.pauseVideo();
    }
  }, [player, isActive])

  const video = useMemo(() => {
    if (isActive) {
      player.playVideo();
    }

    return (
      <div className={cn(styles["video-wrapper"], {[styles["video-wrapper--active"]]: isActive})}>
        <div className={styles["video-iframe"]} id="player"/>
      </div>
    )
  }, [isActive, player])

  return (
    <div className={styles["hero"]}>
      <div className={cn(styles["overlay"], {[styles["overlay--active"]]: isActive})} onClick={handleClose}></div>
      <div className={styles["container"]}>
        <div className={styles["img"]}>
          <Image src={img} quality={100} layout={"responsive"}/>
        </div>
        {video}
        <div className={styles["play-wrapper"]}>
          <button className={styles["play-btn"]} onClick={handleClick}>
            <div className={styles["play-icon"]}>
              <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none">
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M19.5 39C30.2696 39 39 30.2696 39 19.5C39 8.73045 30.2696 0 19.5 0C8.73045 0 0 8.73045 0 19.5C0 30.2696 8.73045 39 19.5 39ZM15.6 13.3801V25.6199C15.6 26.3685 16.4087 26.8379 17.0587 26.4664L27.7686 20.3465C28.4236 19.9722 28.4236 19.0278 27.7686 18.6535L17.0587 12.5336C16.4087 12.1621 15.6 12.6315 15.6 13.3801Z"
                      fill="white"/>
              </svg>
            </div>
            <span className={styles["play-text"]}>{t("hero.btnText")}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Index;